<template src="./registration.html"></template>

<script>
import Vue from 'vue'
import { EventBus } from '@/router/bus'
import Vuelidate from 'vuelidate'
import { required, email, maxLength, minLength, helpers } from 'vuelidate/lib/validators'
import Autocomplete from '@/components/misc/autocomplete/Autocomplete'
import { validationMixin } from '@/mixins/validation'
import { mask } from 'vue-the-mask'
import AlertContainer from '@/components/header/alert-container/AlertContainer.vue'

Vue.use(Vuelidate)

const contactSeparatorRegex = /(?:,|;| )+/

export default {
  name: 'registration',
  mixins: [validationMixin],
  directives: { mask },
  components: {
    Autocomplete,
    AlertContainer
  },
  data () {
    return {
      loading: false,
      registrationAllowed: Vue.$config.registration_allowed,
      identificationNumberMask: '#########',
      phoneNumberMask: '(##) ### ####',
      registrationHelp: (Vue.$config.help_root + '/' + Vue.$helpConfig.registration).replace(/([^:]\/)\/+/g, '$1'),
      budgetUser: {
        id: '',
        taxIdNumber: '',
        companyNumber: '',
        name: '',
        address: '',
        phoneNumber: '',
        email: '',
        supportPhoneNumbers: '',
        supportEmails: '',
        treasuryBranchCode: ''
      },
      register: {
        id: '',
        taxIdNumber: '',
        companyNumber: '',
        executionAccount: '',
        name: '',
        address: '',
        phoneNumber: '',
        email: '',
        supportPhoneNumbers: '',
        supportEmails: '',
        treasuryBranchCode: '',
        adminName: '',
        adminIdentityNumber: '',
        adminEmail: '',
        adminPhoneNumber: '',
        registrationToken: null
      },
      confirmation: {
        id: '',
        registrationToken: ''
      },
      editRegistrationModal: false,
      registrationToExport: null,
      registerConfirmationModal: false,
      autoCompleteUrl_budgetId: Vue.$apiConfig.budgetUsersGet,
      ouLink: Vue.$config.help_root + '/_files/UTOJ.xls'
    }
  },
  methods: {
    autocompleteFilter (query) {
      // console.log(parseInt(query))
      if (isNaN(parseInt(query))) {
        // we check for name
        return 'filter[name]'
      } else {
        // we check for id
        return 'filter[id]'
      }
    },
    copyRegistrationToken () {
      const registrationToken = document.querySelector('#confirmationRegToken')
      registrationToken.setAttribute('type', 'text')
      registrationToken.select()
      document.execCommand('copy')
      registrationToken.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    },
    budgetUserSelected (budgetUser) {
      if (!this.isObject(budgetUser)) {
        this.clearRegisterModelData()
        return
      }
      this.register.id = budgetUser.id
      this.register.taxIdNumber = budgetUser.taxIdNumber
      this.register.name = budgetUser.name
      this.register.companyNumber = budgetUser.companyNumber
      this.register.executionAccount = budgetUser.executionAccount
      this.register.address = budgetUser.address
      this.register.email = budgetUser.email
      this.register.phoneNumber = budgetUser.phoneNumber
    },
    validateBeforeSubmit () {
      this.$v.$touch()
      console.log(this.$t('errors.someErrorsOccuredCheckListBelow'))
      if (this.$v.$invalid) {
        EventBus.$emit('alert', {
          variant: 'error',
          message: this.$t('errors.someErrorsOccuredCheckListBelow'),
          errors: this.getValidationErrors('register')
        })

        this.$nextTick(function () {
          document.body.scrollTop = 0
        })
        return
      }
      this.submit()
    },
    submit () {
      const splitSupportEmails = this.register.supportEmails ? this.register.supportEmails.split(contactSeparatorRegex) : null
      const splitSupportPhoneNumbers = this.register.supportPhoneNumbers ? this.register.supportPhoneNumbers.split(contactSeparatorRegex) : null
      if (this.register.registrationToken) {
        this.updateRequest(splitSupportEmails, splitSupportPhoneNumbers)
      } else {
        this.createRequest(splitSupportEmails, splitSupportPhoneNumbers)
      }
    },
    createRequest (splitSupportEmails, splitSupportPhoneNumbers) {
      this.loading = true
      this.$http.post(Vue.$apiConfig.registerOrganizationPost, { ...this.register, supportEmails: splitSupportEmails, supportPhoneNumbers: splitSupportPhoneNumbers }).then(
        response => {
          this.loading = false
          this.registrationToExport = Object.assign({}, response.data.payload.organization)
          this.confirmation.id = response.data.payload.organization.id
          this.confirmation.registrationToken = response.data.payload.organization.registrationToken
          this.registerConfirmationModal = true
          setTimeout(() => {
            this.clearRegisterModelData()
            this.$refs.registerForm.reset()
            this.$v.$reset()
          }, 1)
        },
        error => {
          this.formatErrorResponse(error, 'register.registrationLimitExceeded')
          this.loading = false
        }
      )
    },
    updateRequest (splitSupportEmails, splitSupportPhoneNumbers) {
      this.loading = true
      this.$http.put(Vue.$apiConfig.registerOrganizationPost, { ...this.register, supportEmails: splitSupportEmails, supportPhoneNumbers: splitSupportPhoneNumbers }).then(
        response => {
          this.loading = false
          this.registrationToExport = Object.assign({}, response.data.payload.organization)
          this.confirmation.id = response.data.payload.organization.id
          this.confirmation.registrationToken = response.data.payload.organization.registrationToken
          this.registerConfirmationModal = true
          setTimeout(() => {
            this.clearRegisterModelData()
            this.$refs.registerForm.reset()
            this.$v.$reset()
          }, 1)
        },
        error => {
          this.formatErrorResponse(error, 'register.registrationLimitExceeded')
          this.loading = false
        }
      )
    },
    printRegistration () {
      this.exportRegistration(this.registrationToExport, this.$refs.imgToExport)
    },
    sendRegistrationToken () {
      this.loading = true
      this.$http
        .post(Vue.$apiConfig.registrationTokenPost, { registrationToken: this.register.registrationToken })
        .then(
          response => {
            this.loading = false
            this.registrationToExport = null
            const payload = response.data.payload
            this.register.id = payload.id
            this.register.taxIdNumber = payload.taxIdNumber
            this.register.companyNumber = payload.companyNumber
            this.register.executionAccount = payload.executionAccount
            this.register.name = payload.name
            this.register.address = payload.address
            this.register.phoneNumber = payload.phoneNumber
            this.register.email = payload.email
            this.register.supportPhoneNumbers = payload.supportPhoneNumbers
            this.register.supportEmails = payload.supportEmails
            this.register.treasuryBranchCode = payload.treasuryBranchCode
            this.register.adminName = payload.adminName
            this.register.adminIdentityNumber = payload.adminIdentityNumber
            this.register.adminEmail = payload.adminEmail
            this.register.adminPhoneNumber = payload.adminPhoneNumber
            this.register.registrationToken = payload.registrationToken

            this.$refs.budgetUserAutocomplete.setContents(
              this.register.id
            )
            this.editRegistrationModal = false
          },
          error => {
            this.editRegistrationModal = false
            this.registrationToken = ''
            this.loading = false
            this.formatErrorResponse(
              error,
              'register.registrationLimitExceeded'
            )
          }
        )
    },
    closeConfirmationModal () {
      this.registerConfirmationModal = false
    },
    prepareBudgetUsersResponseData (data) {
      return data.body.payload
    },
    clearRegisterModelData () {
      this.register.id = ''
      this.register.taxIdNumber = ''
      this.register.executionAccount = ''
      this.register.companyNumber = ''
      this.register.name = ''
      this.register.address = ''
      this.register.phoneNumber = ''
      this.register.email = ''
      this.register.supportPhoneNumbers = ''
      this.register.supportEmails = ''
      this.register.adminName = ''
      this.register.adminIdentityNumber = ''
      this.register.adminEmail = ''
      this.register.adminPhoneNumber = ''
      this.register.registrationToken = null
    },
    getValidationErrorsByName (name) {
      if (!this.$v.register[name].$dirty) return []
      return this.getValidationErrors('register').filter((x) => { return x.field === name }).map(x => x.msg)
    }
  },
  computed: {
    registrationToken: {
      get () {
        return this.register.registrationToken
      },
      set (val) {
        this.register.registrationToken = val.trim()
      }
    },
    budgetUserIdErrors () {
      return this.getValidationErrorsByName('id')
    },
    companyNumberErrors () {
      return this.getValidationErrorsByName('companyNumber')
    },
    taxIdNumberErrors () {
      return this.getValidationErrorsByName('taxIdNumber')
    },
    nameErrors () {
      return this.getValidationErrorsByName('name')
    },
    addressErrors () {
      return this.getValidationErrorsByName('address')
    },
    supportEmailsErrors () {
      return this.getValidationErrorsByName('supportEmails')
    },
    supportPhoneNumbersErrors () {
      return this.getValidationErrorsByName('supportPhoneNumbers')
    },
    adminNameErrors () {
      return this.getValidationErrorsByName('adminName')
    },
    adminIdentityNumberErrors () {
      return this.getValidationErrorsByName('adminIdentityNumber')
    },
    adminEmailErrors () {
      return this.getValidationErrorsByName('adminEmail')
    },
    adminPhoneNumberErrors () {
      return this.getValidationErrorsByName('adminPhoneNumber')
    }
  },
  validations () {
    const rules = {}

    const phoneRegex = /^(\d|-|\(|\)|\/|\\|\+){9,20}$/
    helpers.regex('phone', phoneRegex)
    const supportPhoneNumbers = (value) => {
      if (!value || value.length === 0) return true

      const splitPhones = value.split(contactSeparatorRegex)
      for (let i = 0; i < splitPhones.length; i++) {
        if (!phoneRegex.test(splitPhones[i])) return false
      }

      return true
    }

    const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
    const supportEmails = (value) => {
      if (!value || value.length === 0) return true

      const splitEmails = value.split(contactSeparatorRegex)
      for (let i = 0; i < splitEmails.length; i++) {
        if (!emailRegex.test(splitEmails[i])) return false
      }

      return true
    }

    Object.assign(rules, {
      id: {
        required
      },
      companyNumber: {
        required
      },
      taxIdNumber: {
        required
      },
      name: {
        required
      },
      address: {
        required
      },
      supportEmails: {
        maxLength: maxLength(1000),
        supportEmails
      },
      supportPhoneNumbers: {
        maxLength: maxLength(1000),
        supportPhoneNumbers
      },
      adminName: {
        required
      },
      adminIdentityNumber: {
        maxLength: maxLength(9),
        minLength: minLength(9),
        required
      },
      adminEmail: {
        required,
        email
      },
      adminPhoneNumber: {
        required
      }
    })

    return {
      register: rules
    }
  }
}
</script>

<style lang="scss" scoped>
h4 {
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
